export const maximumNumberValue: number = Math.pow(2, 31) - 1;
